var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-list-item ui-elevation-1 panel" },
    [
      _c("div", { staticClass: "session-list-item__wrapper" }, [
        _c("div", { staticClass: "session-list-item__video" }, [
          _vm.session.established === 1 && _vm.streamServer
            ? _c(
                "div",
                { staticStyle: { height: "inherit" } },
                [
                  _c("web-player-stream", {
                    attrs: {
                      "setup-wait": 15000,
                      "show-unavailable": false,
                      stream: {
                        server: _vm.streamServer,
                        site: _vm.site,
                        streamId: _vm.session.stream_id,
                        title: _vm.streamTitle,
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("stream-statistics", {
        attrs: { session: _vm.session, "stream-title": _vm.streamTitle },
        on: {
          toggleFavorite: _vm.toggleFavorite,
          stop: function ($event) {
            return _vm.$emit("stop", _vm.session)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }